import { useContext } from 'react'
import { Circle, Center } from '@chakra-ui/react'
import { CanvasDrawContext } from './CanvasDrawF'

export const ChooseCursorSize = () => {
  const {cursorSize, setCursorSize, activeColor} = useContext(CanvasDrawContext)

  const sizeOptions = [3, 5, 7, 9, 12, 16]

  return sizeOptions.map((size) => {
    const onClick = () => setCursorSize(size)
    const isActive = (size == cursorSize)
    const style = {
      width: size * 2,
      height: size * 2,
    }
    const boxSize = '45px'
    return <Center key={size} {...{w: boxSize, h: boxSize, onClick, borderBottom: isActive ? `3px solid black` : undefined}}>
      <Circle {...{style, bg: activeColor}} />
    </Center>
  })
}